import { PublicTranslationResolver, PublicTranslationService } from '@capturum/complete';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Locale, PublicLocaleService } from '../../public/questionnaire/services/public-locale.service';
import { map, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class LgPublicTranslationResolver extends PublicTranslationResolver {
  private readonly publicTranslateService = inject(PublicTranslationService);
  private readonly publicLocaleService = inject(PublicLocaleService);
  private readonly translateService = inject(TranslateService);

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const rawLocale = route.queryParams.locale ?? this.publicLocaleService.locale;

    const locale = rawLocale === Locale.GR ? Locale.EL : rawLocale;

    return this.publicTranslateService.loadFilteredTranslations([], locale).pipe(
      tap(() => {
        this.translateService.use(locale);
      }),
      map(() => {
        return true;
      })
    );
  }
}
